package co.maytes.standupbot.dashboard.pages.app.standups.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import co.maytes.standupbot.dashboard.components.widgets.Button
import co.maytes.standupbot.dashboard.components.widgets.ButtonVariant
import co.maytes.standupbot.dashboard.components.widgets.FormRow
import co.maytes.standupbot.dashboard.components.widgets.SectionCard
import co.maytes.standupbot.dashboard.components.widgets.Switch
import co.maytes.standupbot.dashboard.components.widgets.TextInput
import co.maytes.standupbot.dashboard.features.standups.AtRiskForm
import co.maytes.standupbot.dashboard.styles.Palette
import co.maytes.standupbot.dashboard.styles.Spacing
import co.maytes.standupbot.dashboard.styles.Typography
import co.maytes.standupbot.shared.dto.standup.StandupDto
import co.maytes.standupbot.shared.dto.standup.UpdateStandupRequestDto
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.silk.components.text.SpanText

@Composable
internal fun AtRiskCard(
    standup: StandupDto,
    inFlight: Boolean,
    onSave: (UpdateStandupRequestDto) -> Unit,
) {
    var draft by remember(standup.id, standup.atRisk) { mutableStateOf(AtRiskForm.draftOf(standup.atRisk)) }
    val dirty = AtRiskForm.isDirty(draft, standup.atRisk)

    SectionCard(
        title = "At-risk heads-up",
        description = "Name work that is quietly stuck in the post, once, without anyone typing it.",
    ) {
        Column(modifier = Modifier.fillMaxWidth().gap(Spacing.lg)) {
            SpanText(
                text = AtRiskForm.statusLine(standup.atRisk),
                modifier = Modifier.fontSize(Typography.bodySmall.size).color(Palette.textSecondary),
            )
            FormRow(label = "Stale issue after (working days)", hint = AtRiskForm.STALE_HINT) {
                TextInput(
                    value = draft.staleIssueDays,
                    onValueChange = { draft = draft.copy(staleIssueDays = it) },
                    placeholder = "Off",
                    ariaLabel = "Stale issue threshold in working days",
                    error = AtRiskForm.error(draft.staleIssueDays),
                    disabled = inFlight,
                    numeric = true,
                )
            }
            FormRow(label = "Unreviewed pull request after (working days)", hint = AtRiskForm.PR_HINT) {
                TextInput(
                    value = draft.prReviewWaitDays,
                    onValueChange = { draft = draft.copy(prReviewWaitDays = it) },
                    placeholder = "Off",
                    ariaLabel = "Unreviewed pull request threshold in working days",
                    error = AtRiskForm.error(draft.prReviewWaitDays),
                    disabled = inFlight,
                    numeric = true,
                )
            }
            Switch(
                checked = draft.includeBlocked,
                onCheckedChange = { draft = draft.copy(includeBlocked = it) },
                label = AtRiskForm.BLOCKED_LABEL,
                ariaLabel = AtRiskForm.BLOCKED_LABEL,
                disabled = inFlight,
            )
            SpanText(
                text = AtRiskForm.RULE_NOTE,
                modifier = Modifier.fontSize(Typography.caption.size).color(Palette.textTertiary),
            )
            Row(
                modifier = Modifier.fillMaxWidth().gap(Spacing.sm),
                horizontalArrangement = Arrangement.End,
                verticalAlignment = Alignment.CenterVertically,
            ) {
                Button(
                    label = "Reset",
                    variant = ButtonVariant.Ghost,
                    enabled = dirty && !inFlight,
                    onClick = { draft = AtRiskForm.draftOf(standup.atRisk) },
                )
                Button(
                    label = if (inFlight) "Saving…" else "Save",
                    variant = ButtonVariant.Primary,
                    enabled = AtRiskForm.canSave(draft, standup.atRisk) && !inFlight,
                    onClick = { AtRiskForm.request(draft)?.let(onSave) },
                )
            }
        }
    }
}
